import { RootState } from 'src/redux/store';
import { TToastState } from 'src/redux/toast/toast.types';

export const selectToastList = (state: RootState): TToastState['toastList'] =>
  state.toast.toastList;
